import clsx from 'clsx';
import { ChevronDown } from 'lucide-react';
import type React from 'react';
import styles from './Select.module.scss';

export type SelectState = 'success' | 'error';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  id: string;
  options: SelectOption[];
  placeholder?: string;
  state?: SelectState;
}

export const Select: React.FC<SelectProps> = ({ id, options, placeholder, state, ...props }) => (
  <div
    className={clsx(styles.wrapper, {
      [styles.success]: state === 'success',
      [styles.error]: state === 'error',
    })}
  >
    <select className={styles.select} id={id} {...props}>
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options.map((option) => (
        <option key={option.value} value={option.value} disabled={option.disabled}>
          {option.label}
        </option>
      ))}
    </select>
    <ChevronDown className={clsx(styles.icon)} aria-hidden="true" />
  </div>
);
